// utils/validationHelpers.js
export const validators = {
    name: (value) =>
        /^[A-Za-zÄäÖöÜüß0-9\s\-.,]{2,}$/.test(value.trim()) || 'Bitte gib einen gültigen Eventnamen an.',
    startTime: (value) => !!value || 'Startzeit ist erforderlich.',
    endTime: (value, form) => {
        if (!value) return 'Endzeit ist erforderlich.';
        if (form.startTime && new Date(value) <= new Date(form.startTime))
            return 'Endzeit muss nach der Startzeit liegen.';
        return true;
    },
    street: (value) =>
        /^[A-Za-zÄäÖöÜüß\s\-]{2,}$/.test(value.trim()) || 'Straße darf nur Buchstaben enthalten.',
    streetNumber: (value) =>
        /^[0-9]{1,4}[A-Za-z]?$/.test(value.trim()) || 'Straßennummer muss gültig sein.',
    postalCode: (value) =>
        /^[0-9]{5}$/.test(value.trim()) || 'PLZ muss genau 5 Ziffern haben.',
    city: (value) =>
        /^[A-Za-zÄäÖöÜüß\s\-]{2,}$/.test(value.trim()) || 'Stadt darf nur Buchstaben enthalten.',
    country: (value) =>
        /^[A-Za-zÄäÖöÜüß\s\-]{2,}$/.test(value.trim()) || 'Land darf nur Buchstaben enthalten.',
    numberLeader: (value) => {
        const num = Number(value);
        return (num >= 0) || 'Anzahl der Teamleiter muss eine positive Zahl sein.';
    },
    numberInstructors: (value) => {
        const num = Number(value);
        return (num >= 0) || 'Anzahl der Ausbilder muss eine positive Zahl sein.';
    },
    numberMechanics: (value) => {
        const num = Number(value);
        return (num >= 0) || 'Anzahl der Mechaniker muss eine positive Zahl sein.';
    },
    numberGuestManagers: (value) => {
        const num = Number(value);
        return (num >= 0) || 'Anzahl der Gastmanager muss eine positive Zahl sein.';
    },
};

export const validateEmployeeCounts = (form) => {
    const total = Number(form.numberLeader) + Number(form.numberInstructors) + Number(form.numberMechanics) + Number(form.numberGuestManagers);
    return total > 0 || 'Mindestens eine Mitarbeiterrolle muss größer als 0 sein.';
};

export const autoFormat = {
    city: (v) => v.trim().replace(/\b\w/g, c => c.toUpperCase()),
    country: (v) => v.trim().replace(/\b\w/g, c => c.toUpperCase()),
    default: (v) => v.trim(),
};
